import { Iata } from '@reward-platform/shared-schemas'

export type OpCoConfigKey = Iata

type AuthConfig = {
  issuer?: string
  clientId?: string
  clientSecret?: string
  audience?: string
  scope?: string
  cacheLocation?: string
}

const AUTH0_OPCO_CONFIG: Record<OpCoConfigKey, AuthConfig> = {
  EI: {
    issuer: process.env.AUTH0_EI_ISSUER,
    clientId: process.env.AUTH0_EI_CLIENT_ID,
    clientSecret: process.env.AUTH0_EI_CLIENT_SECRET,
    audience: process.env.AUTH0_EI_AUDIENCE,
    scope: process.env.AUTH0_EI_SCOPE,
    cacheLocation: process.env.AUTH0_EI_CACHE_LOCATION,
  },
  BA: {
    issuer: process.env.AUTH0_BA_ISSUER,
    clientId: process.env.AUTH0_BA_CLIENT_ID,
    clientSecret: process.env.AUTH0_BA_CLIENT_SECRET,
    audience: process.env.AUTH0_BA_AUDIENCE,
    scope: process.env.AUTH0_BA_SCOPE,
    cacheLocation: process.env.AUTH0_BA_CACHE_LOCATION,
  },
  IB: {
    issuer: process.env.AUTH0_IB_ISSUER,
    clientId: process.env.AUTH0_IB_CLIENT_ID,
    clientSecret: process.env.AUTH0_IB_CLIENT_SECRET,
    audience: process.env.AUTH0_IB_AUDIENCE,
    scope: process.env.AUTH0_IB_SCOPE,
    cacheLocation: process.env.AUTH0_IB_CACHE_LOCATION,
  },
}

export const getAuthConfigForOpCo = (iata: OpCoConfigKey): AuthConfig => {
  return AUTH0_OPCO_CONFIG[iata]
}
